import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlidadeConfigModel } from '../../../core/services/models/alidade-config.model';
import { ApiResponseModel } from '../../../shared/models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class LikertService {
  private readonly apiUrlLikert: string;
  private readonly apiUrlQuestions: string;

  constructor(
    @Inject('ALIDADE_CONFIG') config: AlidadeConfigModel,
    private http: HttpClient,
  ) {
    this.apiUrlLikert = `${config.apiURL}/builder/likertScales`;
    this.apiUrlQuestions = `${config.apiURL}/builder/questions`;
  }

  addLikertScale(questionId: number, display: string): Observable<ApiResponseModel<void>> {
    return this.http.post<ApiResponseModel<void>>(`${this.apiUrlQuestions}/${questionId}/likertScales`, {
      display,
    });
  }

  updateLikertScaleDisplay(likertId: number, display: string): Observable<ApiResponseModel<void>> {
    return this.http.put<ApiResponseModel<void>>(`${this.apiUrlLikert}/${likertId}`, { display, idobject: likertId });
  }

  removeLikertScale(likertId: number): Observable<ApiResponseModel<void>> {
    return this.http.delete<ApiResponseModel<void>>(`${this.apiUrlLikert}/${likertId}`);
  }

  updateLikertScaleValue(likertId: number, value: number): Observable<ApiResponseModel<void>> {
    return this.http.put<ApiResponseModel<void>>(`${this.apiUrlLikert}/${likertId}`, { value, idobject: likertId });
  }

  updateLikertScaleCustomValue(likertId: number, customValue: number | null): Observable<ApiResponseModel<void>> {
    return this.http.put<ApiResponseModel<void>>(`${this.apiUrlLikert}/${likertId}`, {
      customValue,
      idobject: likertId,
    });
  }
}
